import { ArbetsorderKartutsnittDTO } from "~app/common/models/planera/v2/ArbetsorderKartutsnittDTO";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderKartutsnittBaseCommand } from "./ArbetsorderKartutsnittBaseCommand";
export class UpdateArbetsorderKartutsnittCommand extends ArbetsorderKartutsnittBaseCommand {
    kartutsnitt: ArbetsorderKartutsnittDTO;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateArbetsorderKartutsnittCommand";

    constructor(kartutsnitt: ArbetsorderKartutsnittDTO, arbetsorderId: number) {
        super(UpdateArbetsorderKartutsnittCommand.$type, CommandType.Replace);
        this.arbetsorderId = arbetsorderId;
        this.kartutsnitt = kartutsnitt;
        this.kartutsnittId = kartutsnitt.guid;
    }
}
